<div class="lvi-content list-view-item-hover py-3">
    <div class="avatar">
        <i class="material-icons-outlined align-middle">person</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <span class="label">{{ data.libelle }}</span>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.accueil.detail.tag.profil'"></strong>
                <span>{{ TypeProfil.getLibelle(translateService, data.fonction) }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="onDelete()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>
